<template>
  <el-dialog
    visible
    :title="!!model.id ? 'Edit Model' : 'Create Model'"
    @close="$emit('update:isShow', false)"
  >
    <el-form
      ref="form"
      v-loading="isSaving"
      :rules="rules"
      :model="model"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="Name"
            prop="name"
          >
            <el-input
              v-model="model.name"
              placeholder="Name"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Type"
            prop="type"
          >
            <el-select
              v-model="model.type"
              placeholder="Model Type"
              :loading="isLoadingTypes"
              class="w-100"
              value-key="id"
            >
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.name"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Manufacturer"
            prop="asset_manufacturer"
          >
            <el-select
              v-model="model.asset_manufacturer"
              placeholder="Manufactuer"
              :loading="isLoadingManufacturers"
              class="w-100"
              value-key="id"
              :disabled="!!model.id"
            >
              <el-option
                v-for="manufacturer in manufacturers"
                :key="manufacturer.id"
                :label="manufacturer.name"
                :value="manufacturer"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Description"
            prop="description"
          >
            <el-input
              v-model="model.description"
              type="textarea"
              :rows="5"
              placeholder="Description"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="default"
        @click.native="$emit('update:isShow', false)"
      >
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="!!model.id ? edit() : create()"
      >
        {{ !!model.id ? 'Edit':'Create' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    model: {
      type: Object,
      required: false,
      default: null
    },
    isShow: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isSaving: false,
      typeList: null,
      isLoadingTypes: false,
      isLoadingManufacturers: false,
      manufacturers: [],
      rules: {
        type: [
          { required: true, message: 'Type of model is required', trigger: 'change' }
        ],
        name: [
          { required: true, message: 'Name of model is required', trigger: 'blur' }
        ],
        description: [
          { required: true, message: 'Description of model is required', trigger: 'blur' }
        ],
        asset_manufacturer: [
          { required: true, message: 'Manufacturer of model is required', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.loadTypeLists()
    this.loadManufacturers()
  },
  methods: {
    loadTypeLists () {
      this.isLoadingTypes = true
      this.$sdk.asset_type.list(builder => {})
        .then(res => {
          this.typeList = res
        })
        .finally(() => { this.isLoadingTypes = false })
    },
    loadManufacturers () {
      this.isLoadingManufacturers = true
      this.$sdk.assetmanufacturer.list()
        .then(res => { this.manufacturers = res })
        .finally(() => { this.isLoadingManufacturers = false })
    },
    create () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.model.create(builder => {
            builder.context = { resource: 'asset_manufacturer', id: this.model.asset_manufacturer.id }
          })
            .then(() => { this.$message.success('Successfully Saved') })
            .finally(() => {
              this.isSaving = false
              this.$emit('reload')
              this.$emit('update:isShow', false)
            })
        }
      })
    },
    edit () {
      this.isSaving = true
      this.model.update()
        .then(() => { this.$message.success('Successfully Saved') })
        .finally(() => {
          this.isSaving = false
          this.$emit('reload')
          this.$emit('update:isShow', false)
        })
    }
  }
}
</script>
